export default __webpack_public_path__ + "static/media/XVS.efc523b2.png";